// Shared font style configurations for consistent typography across components
// Uses CSS variables defined in index.css

export const FONT_STYLES = {
  alga: {
    fontFamily: 'var(--font-alga), sans-serif',
    letterSpacing: '0.05em',
  },
  pioneer: {
    fontFamily: 'var(--font-pioneer), sans-serif',
    letterSpacing: '0.05em',
  },
} as const

export type FontStyle = keyof typeof FONT_STYLES
